module.exports = __webpack_public_path__ + "img/edge_activites_terrain_de_sport.f44838c4.svg";